import * as React from 'react';
import { Bem } from '../../utils';
import { useId } from '../../utils/hooks/useId';
import './HeaderTime.css';
const bem = Bem.create('vai-header-time');
export const HeaderTime = (props) => {
    const id = useId(props.htmlId, ['header time']);
    let timeDetails = null;
    if (props.details) {
        const anotherDetail = props.details[1] || String.fromCharCode(160);
        timeDetails = (React.createElement("span", null,
            props.details[0],
            React.createElement("br", null),
            anotherDetail));
    }
    return (React.createElement("div", { id: id.toString(), "data-ta": props.dataTa, className: bem.block() },
        React.createElement("div", { id: id.copyWith(['time']).toString(), className: bem.element('value')() }, props.time),
        React.createElement("div", { id: id.copyWith(['details']).toString(), className: bem.element('details')() }, timeDetails)));
};
//# sourceMappingURL=HeaderTime.js.map